/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';

@Injectable()
/** this config service is created for images , constant ,logo
 *  and many more purpose ,like the things which are static in
 * our system and all urls are mention in this section
  **/
export class ConfigService {
  private configData;

  /**
    * Creates an instance of ConfigService.
    * in this we set images path
    * menuIcons images path
    * API url
    * menu name
    * @memberOf ConfigService
    */
  constructor() {
    this.configData = {
      images: {
        csxLogo: 'assets/images/csx-logo-white.svg',
        bellIcon: 'assets/images/bell.svg',
        arrow: {
          black: {
            left: 'assets/images/arrow-left-black.svg',
            right: 'assets/images/arrow-right-black.svg'
          },
          blackCircle: {
            left: 'assets/images/arrow_left_circle.svg',
            right: 'assets/images/arrow_right_circle.svg'
          }
        },
        menuIcon: {
          white: {
            terminalIcon: 'assets/images/map-marker-white.svg',
            locomotiveIcon: 'assets/images/electric-white.svg',
            trainIcon: 'assets/images/train-front-white.svg',
            locomotiveStatus: 'assets/images/locomotive_status.svg',
            yardNLocal: 'assets/images/yardLocal-white.svg',
            outlyingPoints: 'assets/images/outlying_point.svg',
            search: 'assets/images/query-view.svg',
            tonnageRatingIcon:'assets/images/tonnage-rating-icon.svg',
            help: 'assets/images/help-white.svg',
            terminalHelp: 'assets/images/common_more_actions.svg',
            listManager: 'assets/images/List_Manager.svg',
            phonebook: 'assets/images/phonebook_white.svg'
          }
        },
        topAction: {
          train: {
            trainNaIcon: 'assets/images/train-NA-icon.svg',
            otherOption: {
              label: ['Other Actions', 'Add Train', 'Complete Train', 'Cancel Train',
                'Set Train Position', 'Plan Locomotive', 'Update Locomotive',
                'Cancel Locomotive Plan'
              ]
            }
          },
          terminal: {
            terminalNAIcon: 'assets/images/terminal-NA-icon.svg',
          },
          locomotive: {
            locomotiveNaIcon: 'assets/images/loco-NA-icon.svg',
            otherOption: {
              label: ['Other Actions', 'Plan Locomotive', 'Locate', 'Update Terminal Handling Plan',
                'Bring Online', 'Add Locomotive', 'Delete Locomotive'
              ]
            }
          }
        }
      },
      urls: {
        API_URL: environment.appConfig.api.lmsApi,
        terminal: {
          status: 'terminals/{search}',
          data: 'terminals//data/{search}'
        }
      },
      tab: {
        defaultDescription: 'New Tab',
        event: {
          add: 'add',
          update: 'update',
          remove: 'remove',
          select: 'select',
          refresh: 'refresh'
        }
      },
      log: {
        level: {
          info: 'info',
          warn: 'warn',
          error: 'error',
          debug: 'debug'
        }
      },
      message: {
        type: {
          client: 'client',
          server: 'server'
        },
        level: {
          info: 'info',
          warn: 'warn',
          error: 'error',
          fatal: 'fatal',
          success: 'success'
        },
        target: {
          page: 'page',
          tab: 'tab',
          popUp: 'popUp'
        }
      },
      menu: {
        defaultType: 'terminal',
        type: {
          terminal: 'Terminal',
          locomotive: 'Locomotive',
          train: 'Train',
          alert: 'Alerts',
          locoStatus: 'Locomotive-Status',
          yardLocal: 'Yard-Local',
          outlyingPoints: 'Outlying-Points',
          queryView: 'Query-View',
          tonnageRating: 'Tonnage-Ratings',
          help: 'Help',
          listManager: 'List Manager',
          terminalHelp: '',
          phonebook: 'Operations Phone Book'
        },
        typeSubtypeMapping: {
          terminal: 'status',
          locomotive: 'data',
          train: 'data',
          locoStatus: 'data',
          yardLocal: 'data',
          outlyingPoints: 'data',
          queryView: 'data',
          help: 'data',
          terminalHelp: 'data',
          alert: 'data'
        },
        url: {
          terminal: '/terminal/status',
          locomotive: '/locomotive',
          train: '/train',
          locoStatus: '/locomotive-status',
          yardLocal: '/yard-local',
          outlyingPoints: '/outlying-points',
          queryView: '/query-view',
          help: '/help-docs',
          alert: '/alert',
          phonebook: '/phonebook',
          terminalHelp: '',
          listManager: '',
          tonnageRating:'/tonnage-ratings'
        },
        subType: {
          status: 'Status',
          handling: 'Handling',
          notes: 'Notes',
          data: 'Data',
          history: 'History',
          profile: 'Profile',
          locoStatus: 'Data',
          alert: 'Data',
          yardLocal: 'Data',
          outlyingPoints: 'Data'
        }
      },
      trainLabel: {
        routeCurrent: 'Current',
        routeNext: 'Next',
        trainSchedule: 'Schedule',
        trainETA: 'ETA',
        trainPTC: 'PTC',
        projectedTonnage: 'Projected Tonnage',
        lastReporting: 'Last Reporting',
        lastReported: 'Last Reported',
        reportedLocation: 'Location',
        hoursNotMoved: 'Hours Not Moved',
        trainName: 'Name',
        trainDetails: 'TRAIN DETAILS',
        hpTT: 'Horsepower per Trailing Ton',
        empty: 'Empty',
        hp: 'Horsepower',
        tons: 'Tons',
        feet: 'Feet',
        loads: 'Loads',
        auto: 'Auto',
        tofc: 'TOFC',
        car: 'Cars',
        trainInformation: 'TRAIN INFORMATION',
        crewOnDuty: 'Crew On Duty',
        crewProjectedFor: 'Crew Projected For',
        origin: 'Origin',
        destination: 'Destination',
        performance: 'Performance',
        empties: 'Empties',
        autos: 'Autos',
        length: 'Length',
        previous: 'Previous',
        scheduled: 'Scheduled',
        note: 'Note',
        powerPlan: 'Power Plan',
        calledTime: 'Called',
        departed: 'Departed'
      },
      locoLabel: {
        qInspection: 'Q Inspection',
        deadDate: 'Dead Date',
        nextDate: 'Next Date',
        nextMaintainance: 'Next Maintenance',
        lastLocation: 'Last Location',
        lastDate: 'Last Date',
        oneEightyFourM: '184M',
        otherInspection: 'Other Inspection',
        next33Day: 'Next 33 Day',
        nextAirFlow: 'Next Air Flow',
        locomotiveMates: 'Locomotive Mates',
        powerUnit: 'Power Unit',
        mate: 'Mate',
        assignment: 'Assignment',
        assignCurrent: 'Current',
        assignHandling: 'Handling',
        noError: 'No reported incident(s)',
        showMore: 'Show More',
        showLess: 'Show Less',
        assignPlanned: 'Planned',
        plannedAssignment: 'Planned Assignment',
        intendedUsage: 'Intended Usage',
        assignPrevious: 'Previous',
        locomotiveInformation: 'Locomotive Information',
        qDate: 'Q-date',
        type: 'Type',
        class: 'Class',
        hp: 'Horsepower',
        te: 'Tractive Effort',
        allocation: 'Allocation',
        allocationInfo: 'Allocation Info',
        ynlLocation: 'Y & L Location',
        permanentTag: 'Permanent Tag',
        oprRegion: 'Operating Region',
        oprZone: 'Operating Zone',
        locomotiveTag: 'Locomotive Tag',
        responsibleRoad: 'Responsible Road',
        Responsible: 'Responsible',
        intgRoad: 'Interchange Road',
        direction: 'Direction',
        telemetry: 'Telemetry',
        lastReported: 'Last Reported',
        lastReportedLocation: 'Last Reported Location',
        lastGps: 'Last',
        currentUsage: 'Current Usage',
        train: 'Train',
        terminal: 'Terminal',
        terminalHandlingPlan: 'Terminal Handling Plan',
        terminalArrival: 'Terminal Arrival',
        terminalDuration: 'Terminal Duration',
        tagPermLoco: 'Tag Perm / Loco',
        reportingSource: 'Reporting Source',
        locationInformation: 'Location Information',
        reportingType: 'Reporting Type',
        first: 'First',
        last: 'Last',
        locoTripPlan: 'Locomotive Trip Plan',
        tripPlan: 'Trip Plan',
        backupTripPlan: 'Backup Trip Plan',
        planCreated: 'Plan Created',
        planDep: 'Dep: ',
        planEta: 'ETA: ',
        fuel: 'Fuel',
        lastFueled: 'Last Fueled',
        hsFuelCount: 'H/S Fuel Count',
        availableCapacity: 'Available Capacity',
        milesLeft: 'Miles Left',
        milesToEmpty: 'Miles to Empty',
        capacity: 'Capacity',
        bulkRange: 'Bulk Range',
        mfstRange: 'MFST Range',
        mixedRange: 'Mixed Range',
        fuelLevel: 'Fuel Level',
        features: 'Features',
        notes: 'Notes',
        sequence: 'Sequence',
        problem: 'Problem',
        problems: 'Problems',
        fueledAt: 'Fueled @',
        dateFueled: 'Date Fueled',
        miles: 'Miles',
        due: 'Due',
        remarks: 'Remarks',
        runDeadiso: 'Running / Dead / Isolated',
        tag: 'Tag',
        tractiveEffort: 'Tractive Effort',
        horsePower: 'Horsepower',
        location: 'Location',
        pickupAt: 'Pickup At',
        resp: 'Resp: ',
        searchLoco: 'Search a Locomotive to display information.',
        locoException: 'Enter valid Locomotive ID',
        partialPower: 'Partial Power',
        trailOnly: 'Trail Only',
        toShop: 'To Shop',
        dead: 'Dead'
      },
      alertLabel: {
        alertLabel: 'Alerts',
        alertDeskSignOff: 'Desk Signoff',
        alertDesk: 'Desk',
        alertDirSignOff: 'Director Signoff',
        alertLocomotive: 'Locomotive',
        alertTrain: 'Train',
        alertTerminal: 'Terminal',
        alertDescription: 'Alert Description',
        alertTag: 'Tag',
        alertCreated: 'Created',
        alertExpired: 'Expiration',
        alertCheckBoxText: 'Show Signed Off Alerts',
        alertLastRefresh: 'Last Refreshed',
        cancelBtn: 'Cancel',
        submitBtn: 'Submit'
      },
      locoStatusLabel: {
        locomotiveId: 'Locomotive ID',
        currentAssignment: 'Current Assignment',
        foreignRoad: 'Foreign Road',
        tag: 'Tag',
        class: 'Class',
        lastReporting: 'Last Reporting',
        cityState: 'City/State',
        planTo: 'Plan to',
        train: 'Train',
        terminal: 'Terminal',
        road: 'Road',
        terminalHandlingPlan: 'Terminal Handling Plan',
        serviceCtrShop: 'Service Ctr / Shop',
        truckFueling: 'Truck Fueling',
        mainTrack: 'Main Track',
        toStorage: 'To Storage',
        locomotives: 'LOCOMOTIVES',
        locomotive: 'LOCOMOTIVE',
        intendedUsage: 'INTENDED USAGE',
        reason: 'REASON',
        notes: 'Notes',
        cancel: 'Cancel',
        submit: 'Submit',
        ok: 'OK',
        planToTrain: 'Plan to Train',
        exception: 'EXCEPTION',
        planLocomotive: 'Plan Locomotive',
        cancelLocomotivePlan: 'Cancel Locomotive Plan',
        setCurrentAssignment: 'Set Current Assignment',
        locomotiveStatus: 'LOCOMOTIVE STATUS',
        locoStatus: 'Locomotive Status',
        addNew: '+ Add New',
        lastRefresh: 'Last Refreshed'
      },
      queryViewLabel: {
        geo: 'Geography',
        terminal: 'Terminal',
        commodity: 'Commodity',
        trains: 'Trains',
        train: 'Train',
        units: 'Units',
        etd: 'ETD',
        corridor: 'Division',
        tmc: 'TMC',
        locomotivesWithBrackets: 'Locomotive(s)',
        locomotives: 'Locomotives',
        locomotive: 'Locomotive',
        locomotiveId: 'Locomotive ID',
        currentAssignment: 'Current Assignment',
        queryView: 'Query View',
        addNew: '+ Add New',
        lastRefresh: 'Last Refreshed',
        location: 'Location',
        destination: 'Destination',
        status: 'Status',
        class: 'Class',
        lastReporting: 'Last Reporting',
        time: 'Time',
        date: 'Date',
        axles: 'Axl',
        ptc: 'PTC',
        lastFueled: 'Last Fueled',
        miles: 'Miles',
        fuel: 'Fuel',
        qDue: 'Q Due',
        serviceDue: 'Service Due',
        deadDate: 'Dead Date',
        nextDays: 'Next 33 Day Inspection',
        nextAirFlow: 'Next Air Flow Calib',
        nextPlannedAssignment: 'Planned Assignment',
        dateTime: 'Date Time',
        type: 'Type',
        city: 'City',
        and: 'and',
        state: 'State',
        permtag: 'Perm Tag',
        oprRegion: 'Operating Region',
        oprZone: 'Operating Zone',
        locotag: 'Loco Tag',
        allocationStation: 'Allocation Station',
        allocationType: 'Alloc Type',
        permAllocation: 'Perm Alloc',
        division: 'Alloc Div',
        typeOfService: 'Type of Service',
        nextQ: 'Next Q Type',
        remarks: 'Remarks',
        oos: 'OOS',
        partialPower: 'Partial Power',
        trailOnly: 'Trail Only',
        workToShop: 'Work to Shop',
        Notes: 'Notes'
      },
      trainProfileLabel: {
        helperSegment: 'Includes helper segment',
        restrictiveSegment: 'Most restrictive segment without helpers',
        restrictiveHelperSegment: 'Helper segment is most restrictive',
        level: 'Level',
        departTime: 'Depart / Time',
        arriveTime: 'Arrive / Time',
        miles: 'Miles',
        helpers: 'Helpers',
        helperConsist: 'Helper Consist',
        projectedTonnage: 'Projected Tons',
        historicalTonnageA: 'Historical Tons',
        historicalTonnageB: '80th Percentile',
        tonnageCapacity: 'Calculated Tonnage Capacity',
        calculator: 'Calculator',
        clear: 'Clear',
        clearAll: 'Clear All',
        MP15: 'MP15',
        MP15T: 'MP15T',
        GP151: 'GP15-1',
        GP15T: 'GP15T',
        GS21B: '3GS21B',
        RDSLUG: 'RDSLUG',
        B208: 'B20-8',
        B408: 'B40-8',
        GP382: 'GP38-2',
        GP402: 'GP40-2',
        SD402: 'SD40-2',
        SD502: 'SD50-2',
        SD503: 'SD50-3',
        SD50: 'SD50',
        SD70M: 'SD70M',
        SD60: 'SD60',
        CW408: 'CW40-8',
        CW449: 'CW44-9',
        C408: 'C40-8',
        CW409: 'CW40-9',
        ES40DC: 'ES40DC',
        ES44DC: 'ES44DC',
        ES44C4: 'ES44C4',
        ET44C4: 'ET44C4',
        SD70AE: 'SD70AE',
        SD70AC: 'SD70AC',
        SD70MA: 'SD70MA',
        CW44AC: 'CW44AC',
        CW46AC: 'CW46AC',
        CW446: 'CW44-6',
        CW60AC: 'CW60AC',
        ET44AC: 'ET44AC',
        SD80AC: 'SD80AC',
        SD90AC: 'SD90AC',
        CW44AH: 'CW44AH',
        CW46AH: 'CW46AH',
        CW60AH: 'CW60AH',
        ES44AH: 'ES44AH',
        ET44AH: 'ET44AH',
        expandAll: 'Expand All',
        plus: '+',
        collapseAll: 'Collapse All',
        minus: '-',
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
        H: 'H',
        I: 'I',
        tonnageRating0: 'tonnageRating0',
        tonnageRating1: 'tonnageRating1',
        tonnageRating2: 'tonnageRating2',
        tonnageRating3: 'tonnageRating3',
        tonnageRating4: 'tonnageRating4',
        tonnageRating5: 'tonnageRating5',
        tonnageRating6: 'tonnageRating6',
        tonnageRating7: 'tonnageRating7',
        tonnageRating8: 'tonnageRating8',
        category0: '00',
        category1: '01',
        category2: '02',
        category3: '03',
        category4: '04',
        category5: '05',
        category6: '06',
        category7: '07',
        category8: '08',
        blank: '',
        blankSpace: ' ',
        clickOnCommonHeading: 'Click on column heading',
        searchTrainProfile: 'Search a Train to display profile information.',
        validTrainProfileId: 'Enter valid Train ID',
        grade: 'GRADE',
        profile: 'PROFILE',
        lms: 'LMS',
        Y: 'Y',
        N: 'N',
        bgGreen: 'bg-green',
        bgYellow: 'bg-yellow',
        greenYellow: 'green-yellow',
        bgAqua: 'bg-aqua',
        trainInquiryFail: 'Train ID Inquiry Failed. Please contact System Support',
        trainProfileNotFoundFirst: 'Train Profile for ',
        trainProfileNotFoundSecond: ' not found',
        success: 'SUCCESS'
      },
      yardLocalLabel: {
        addAllocationStation: 'Add Allocation Station',
        updateAllocationStation: 'Update Allocation Station',
        deleteAllocationStation: 'Delete Allocation Station',
        yardAndLocal: 'Yard & Local',
        mow: 'MOW',
        specialAllocations: 'Special Allocations',
        all: 'All',
        includeSpecialAllocations: 'Include Special Allocations',
        plan: 'Plan',
        allocate: 'Allocate',
        deallocate: 'Deallocate',
        corridor: 'Division',
        oprZone: 'Operating Zone',
        allocationStation: 'Allocation Station',
        lastRefreshed: 'Last Refreshed',
        sortBy: 'Sort by:',
        alphabeticByDivision: 'Alphabetic by Station',
        netAllocation: ' Net Allocation',
        extraPower: 'Extra Power',
        netAlloc: 'Net Alloc',
        allocated: 'Allocated',
        shoppedStoredOOS: 'Shopped/Stored/OOS (Pink)',
        outsideGeofence: 'Outside Geofence (Grey)',
        netAllocated: 'Net Allocated',
        planPercent: 'Plan Percent',
        otherYLUnit: 'Other Y/L Units',
        roadUnits: 'Road Units',
        availableVsPlan: 'Available vs. Plan (Extra Power)',
        planTo: 'Plan to',
        train: 'Train',
        terminal: 'Terminal',
        terminalHandlingPlan: 'Terminal Handling Plan',
        allocationType: 'Allocation Type',
        serviceCtrShop: 'Service Ctr / Shop',
        truckFueling: 'Truck Fueling',
        mainTrack: 'Main Track',
        toStorage: 'To Storage',
        locomotives: 'Locomotives',
        locomotive: 'Locomotive',
        intendedUsage: 'Intended Usage',
        reason: 'Reason',
        notes: 'Notes',
        cancel: 'Cancel',
        submit: 'Submit',
        yardLocal: 'Yard/Local',
        permanentAllocation: 'Permanent Allocations',
        specialAllocation: 'Special Allocation',
        no: 'No',
        yes: 'Yes',
        find: 'Find',
        stationCityState: 'Station City State',
        roadTerminal1: 'Road Terminal 1',
        transitHours: 'Transit Hours',
        roadTerminal2: 'Road Terminal 2',
        fourAxle: '4 Axle',
        fourAxlePTC: '4 Axle PTC',
        fourAxleRCL: '4 Axle RCL',
        fourAxlePTCRCL: '4 Axle PTC-RCL',
        sixAxle: '6 Axle',
        sixAxlePTC: '6 Axle PTC',
        sixAxleRCL: '6 Axle RCL',
        sixAxlePTCRCL: '6 Axle PTC-RCL',
        platform: 'Platform',
        slug: 'Slug',
        ptcSlug: 'PTC Slug'
      },
      outlyingPointLabel: {
        WTL: 'WTL',
        WOTL: 'WOTL',
        ALL: 'All',
        threeZero: '000',
        showOutlyingPoints: 'Show Outlying Points: ',
        withTrainAndLocomotive: 'With Trains or Locomotives',
        withoutTrainAndLocomotive: 'Without Trains or Locomotives',
        commonopsPicklist: 'commonopsPicklist',
        outlyingPointDataId: 'outlyingPointDataId',
        px: 'px',
        scroll: 'scroll',
        style: 'style',
        marginRight: 'margin-right: 21px',
        terminalMnemonic: 'terminalMnemonic',
        minus: '-',
        commaSpace: ', ',
        showing: 'Showing',
        blank: '',
        to: 'to',
        of: 'of',
        records: 'records',
        terminal: 'Terminal',
        Mnemonic: 'Mnemonic',
        Trains: 'Trains',
        LocoAssigned: 'Loco Assigned',
        Road: 'Road',
        Yard: 'Yard',
        MOW: 'MOW',
        TOTAL: 'TOTAL'
      },
      notesLabel: {
        searchLocoNotes: 'Search a Locomotive to display notes information.',
        searchTrainNotes: 'Search a Train to display notes information.',
        searchTerminalNotes: 'Search a Terminal to display notes information.',
      },
      tabStatus: {
        blank: 'blank',
        loaded: 'loaded',
        error: 'error',
        refresh: 'refresh',
        add: 'add'
      },
      tabIndex: {
        sideNavigation: 1,
        topTabs: 1500,
        subTabs: 2500,
        detailPage: 3500,
        userInfo: 6000,
        dialogBox: 8000
      },
      messages: {
        invalidTerminal: 'Please add a valid Terminal Mnemonic',
        invalidTrain: 'Train not on LMS Train Database',
        invalidLocomotive: 'Locomotive not on Equipment Database',
        invalidFormatTrain: 'Train ID is not a valid CSX format',
        maxTab: 'Maximum 20 tabs are allowed',
        internalServerError: 'Internal Server Error',
        offlineError: 'Unable to connect to server, please verify internet settings and retry after some time',
        sessionExpiredError: 'Session expired, please close the current instance and open a new window',
        defaultWindowExist: 'Same default window already exists. Please check',
        planInvalidTerminal: 'Please select a correct Terminal',
        planInvalidRoad: 'A valid Transfer Road is required',
        planInvalidTrainId: 'Please select a valid train.',
        planInvalidInterchangeRoad: 'No roads valid for interchange at this station',
        userSettingSuccess: 'User settings saved successfully. Changed settings will appear in next user session',
        locoStatusDuplicateId: 'Duplicate Locomotive IDs',
        cancelLocomotiveInvalid: 'The locomotive must be planned before performing a cancel.',
        blankLocoStatusWindow: 'You must enter at least 1 Locomotive ID in the grid',
        noLocoStatusFound: 'Locomotive Not Found',
        invalidLocomotiveId: 'Enter valid Locomotive ID',
        noRecordFound: 'No Record Found',
        editModePopUp: 'Unsaved data will be lost. Do you want to continue?',
        deleteAllNote: 'Are you sure you want to Delete all the Notes?',
        deleteSelectedNote: 'Are you sure you want to delete the selected notes?',
        invalidTrainId: 'Enter valid Train ID',
        invalidTerminalId: 'Enter valid Terminal Mnemonic',
        planInvalidAllocationStation: 'Please select a correct Allocation Station',
        terminalStatusDefaultView: 'Search an Operating Zone & Allocation Station to display information.',
        dellocateLocomotiveConfirmation: 'Are you sure you want to Deallocate locomotives ?',
        searchOutlyingMessage: 'Select a Desk to display information.',
        addInvalidDivision: 'Please select a correct Division',
        addInvalidAlocStation: 'Please enter a correct Allocation Station',
        addInvalidTransitHours: 'Please enter valid Transit Hours',
        addInValidSchdQMin: 'Please enter valid Days',
        invalidThpSelection: 'Change the Terminal Handling selection - there is no Service Center/Shop at this Terminal',
        invalidNumber: 'Please enter a valid #',
        locomotiveAlreadyExists: 'Duplicate locomotive request'
      },
      dialog: {
        planLocomotive: {
          planOptions: {
            foreignRailRoad: 'Foreign Railroad',
            train: 'Train',
            terminal: 'Terminal'
          }
        }
      },
      daySpinner: {
        values: [
          { label: '01', value: 1 },
          { label: '02', value: 2 },
          { label: '03', value: 3 },
          { label: '04', value: 4 },
          { label: '05', value: 5 },
          { label: '06', value: 6 },
          { label: '07', value: 7 },
          { label: '08', value: 8 },
          { label: '09', value: 9 },
          { label: '10', value: 10 },
          { label: '11', value: 11 },
          { label: '12', value: 12 },
          { label: '13', value: 13 },
          { label: '14', value: 14 },
          { label: '15', value: 15 },
          { label: '16', value: 16 },
          { label: '17', value: 17 },
          { label: '18', value: 18 },
          { label: '19', value: 19 },
          { label: '20', value: 20 },
          { label: '21', value: 21 },
          { label: '22', value: 22 },
          { label: '23', value: 23 },
          { label: '24', value: 24 },
          { label: '25', value: 25 },
          { label: '26', value: 26 },
          { label: '27', value: 27 },
          { label: '28', value: 28 },
          { label: '29', value: 29 },
          { label: '30', value: 30 }
        ],
      },
      deskOptions: {
        values: [
          { value: '', label: 'Select Desk' },
          { value: 'D-1', label: 'D-1  HUNTINGTON' },
          { value: 'D-2', label: 'D-2  LOU-NAS' },
          { value: 'D-3', label: 'D-3  CHICAG' },
          { value: 'D-4', label: 'D-4  ALB-GL' },
          { value: 'D-5', label: 'D-5  BALT-FLO' },
          { value: 'D-6', label: 'D-6  ATL-JAX' },
          { value: 'N-12', label: 'N-12  HUNTY-LOU-NAS' },
          { value: 'N-34', label: 'N-34  CHICAG-ALB-GL' },
          { value: 'N-56', label: 'N-56  LOU-NAS-ALT-JAX' },
          { value: 'L001', label: 'L001  CENTRAL DESK' },
          { value: 'L002', label: 'L002  NORTHWEST DESK' },
          { value: 'L004', label: 'L004  SOUTHEAST DESK' },
          { value: 'L005', label: 'L005  NORTHEAST DESK' }
        ],
      },
      spinnerValue: {
        values: [
          { value: 12, label: '12' },
          { value: 16, label: '16' },
          { value: 24, label: '24' },
          { value: 36, label: '36' },
          { value: 48, label: '48' },
          { value: 60, label: '60' },
          { value: 72, label: '72' }
        ],
      }
    };
  }

  /**
   * @returns
   * @memberOf ConfigService
   */
  getConfigData() {
    return this.configData;
  }
}
